<div class="profession-detail" *ngIf="profession">
  <!-- Hero with nav arrows -->
  <div class="profession-detail__hero">
    <button class="profession-detail__nav-btn profession-detail__nav-btn--prev" [disabled]="!canGoPrevious" (click)="goPrevious()">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="m15 18-6-6 6-6"/></svg>
    </button>
    <button class="profession-detail__nav-btn profession-detail__nav-btn--next" [disabled]="!canGoNext" (click)="goNext()">
      <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="m9 18 6-6-6-6"/></svg>
    </button>
  </div>

  <div class="profession-detail__body">
    <button class="profession-detail__back" (click)="goBack()">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="m15 18-6-6 6-6"/></svg>
      <span>{{ 'shared.back' | translate }}</span>
    </button>

    <!-- Main card with sidebar -->
    <div class="profession-detail__card">
      <div class="profession-detail__main">
        <!-- Header -->
        <div class="profession-detail__header">
          <div class="profession-detail__meta">
            <span>{{ profession.sector }}</span>
            <span>{{ 'professions.detail.vacancy_match' | translate }} <strong>{{ profession.matchScore }}%</strong></span>
          </div>
          <h1 class="profession-detail__title">{{ profession.title }}</h1>
        </div>

        <!-- Skills match -->
        <div class="profession-detail__skills-section">
          <div class="profession-detail__skill-group" *ngIf="profession.skillsMatch?.length">
            <h3>{{ 'professions.detail.skills_match' | translate }}</h3>
            <div class="profession-detail__skill-pills">
              <span *ngFor="let skill of profession.skillsMatch" class="profession-detail__pill profession-detail__pill--match">{{ skill.name }}</span>
            </div>
          </div>

          <div class="profession-detail__skill-group" *ngIf="profession.skillsClose?.length">
            <h3>{{ 'professions.detail.close_match' | translate }}</h3>
            <div class="profession-detail__skill-pills">
              <span *ngFor="let skill of profession.skillsClose" class="profession-detail__pill profession-detail__pill--close">{{ skill.name }}</span>
            </div>
          </div>

          <div class="profession-detail__skill-group" *ngIf="profession.skillsGap?.length">
            <h3>{{ 'professions.detail.skills_gap' | translate }}</h3>
            <div class="profession-detail__skill-pills">
              <span *ngFor="let skill of profession.skillsGap" class="profession-detail__pill profession-detail__pill--gap">{{ skill.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Sidebar -->
      <div class="profession-detail__sidebar">
        <div class="profession-detail__sidebar-item">
          <span class="profession-detail__sidebar-label">{{ 'professions.detail.education_level' | translate }}</span>
          <span class="profession-detail__sidebar-value">{{ profession.educationLevel }}</span>
        </div>
        <div class="profession-detail__sidebar-item">
          <span class="profession-detail__sidebar-label">{{ 'professions.detail.job_chances' | translate }}</span>
          <span class="profession-detail__sidebar-value">{{ profession.jobMarketChances }}</span>
        </div>
        <div class="profession-detail__sidebar-item">
          <span class="profession-detail__sidebar-label">{{ 'professions.detail.future_job_chances' | translate }}</span>
          <span class="profession-detail__sidebar-value">{{ profession.futureProspects }}</span>
        </div>
        <div class="profession-detail__sidebar-item">
          <span class="profession-detail__sidebar-label">{{ 'professions.detail.ai_impact' | translate }}</span>
          <span class="profession-detail__sidebar-value">{{ profession.aiImpact }}</span>
        </div>
        <div class="profession-detail__sidebar-item">
          <span class="profession-detail__sidebar-label">{{ 'professions.detail.salary_month' | translate }}</span>
          <span class="profession-detail__sidebar-value">{{ profession.salaryRange }}</span>
        </div>
        <div class="profession-detail__sidebar-item">
          <span class="profession-detail__sidebar-label">{{ 'professions.detail.worker_distribution' | translate }}</span>
          <span class="profession-detail__sidebar-value">{{ profession.genderDistribution }}</span>
        </div>

        <div class="profession-detail__sidebar-tags" *ngIf="profession.interestAreas?.length">
          <span class="profession-detail__sidebar-label">{{ 'professions.detail.interest_areas' | translate }}</span>
          <div class="profession-detail__tag-list">
            <span *ngFor="let area of profession.interestAreas" class="profession-detail__tag profession-detail__tag--blue">{{ area }}</span>
          </div>
        </div>

        <div class="profession-detail__sidebar-tags" *ngIf="profession.topSectors?.length">
          <span class="profession-detail__sidebar-label">{{ 'professions.detail.top_sectors' | translate }}</span>
          <div class="profession-detail__tag-list">
            <span *ngFor="let sector of profession.topSectors" class="profession-detail__tag profession-detail__tag--green">{{ sector }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Description -->
    <div class="profession-detail__description-card">
      <h2>{{ 'professions.detail.about_title' | translate }}</h2>
      <div class="profession-detail__description-text">{{ displayedDescription }}</div>
      <button
        *ngIf="profession.description && profession.description.length > 800"
        class="profession-detail__read-more"
        (click)="isExpanded = !isExpanded"
      >
        {{ 'shared.read_more' | translate }}
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" [class.rotated]="isExpanded">
          <path d="m6 9 6 6 6-6"/>
        </svg>
      </button>
    </div>
  </div>

  <!-- Sticky footer -->
  <div class="profession-detail__footer">
    <div class="profession-detail__footer-inner">
      <a [routerLink]="['/profile-check/vacancies']" class="profession-detail__footer-btn profession-detail__footer-btn--primary">
        {{ 'professions.detail.view_vacancies' | translate:{ count: profession.vacatureCount } }}
      </a>
      <button class="profession-detail__footer-btn profession-detail__footer-btn--secondary">
        {{ 'professions.detail.discover_companies' | translate:{ count: profession.bedrijvenCount } }}
      </button>
      <button
        class="vacancy-btn-round vacancy-btn-heart"
        [class.vacancy-btn-heart--active]="isSaved"
        (click)="toggleSave()"
        style="width: 48px; height: 48px;"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" [attr.fill]="isSaved ? 'currentColor' : 'none'" stroke="currentColor" stroke-width="2">
          <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/>
        </svg>
      </button>
    </div>
  </div>
</div>
